'use strict';

module.exports = {
  isFunction: function isFunction(obj) {
    return typeof obj === 'function';
  },
  isString: function isString(obj) {
    return typeof obj === 'string';
  },
  composeErrorMessage: function composeErrorMessage(code, description) {
    return "".concat(code, ", ").concat(description);
  },
  inherits: function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  }
};